// extracted by mini-css-extract-plugin
module.exports = {"Container":"PasswordReset_Container__1lG_-","Input":"PasswordReset_Input__2xvw2","Buttons":"PasswordReset_Buttons__15nya","SpacedButton":"PasswordReset_SpacedButton__3KbpJ"};